import OutlinedInput from "@mui/material/OutlinedInput";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField/TextField";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import React, { useEffect, useState } from "react";

function withPerformance(Component) {
    function WrapperInput(props) {
        const { onChange, value, ...others } = props;

        const [_value, setValue] = useState(value || "");

        useState(() => {
            if (value !== _value) {
                setValue(value);
            }
        }, []);

        useEffect(() => {
            if (value !== _value) {
                setValue(value);
            }
        }, [_value, value]);

        function handleOnChange(e) {
            setValue(e.target.value);
            const target = e.target;
            updateParent({ target });
        }
        function updateParent(e) {
            onChange(e, e.target.value);
        }

        return <Component {...others} value={_value} onChange={handleOnChange} />;
    }
    return WrapperInput;
}

export const PerformanceTextField = withPerformance((props) => <TextField {...props} />);
export const PerformanceTextArea = withPerformance((props) => <TextareaAutosize {...props} />);
export const PerformanceRadioGroup = withPerformance((props) => <RadioGroup {...props} />);
export const PerformanceOutlinedInput = withPerformance((props) => <OutlinedInput {...props} />);

export default withPerformance;
